<template>
  <div class="home-view">
    <div class="titulo" style="margin-top: 2rem">
      <div class="grid-3">
        <div style="text-align: center">
          <h2 style="font-weight: 500; color: var(--cor-fonte-fraca)">{{ getMensagemBemVindo() }}, {{ usuarioLogado.nome.split(" ")[0] }}</h2>
        </div>
        <div aria-hidden="true"></div>
        <div style="text-align: center">
          <h2 style="font-weight: 500; color: var(--cor-fonte-fraca)">
            {{ textoDataHoraRelogio }}
          </h2>
        </div>
      </div>
    </div>
    <div class="home-grid-wrap">
      <div class="margem home-grid home-grid--custom" :class="{ 'home-grid--agenda-recolhida': agendaRecolhida, 'home-grid--noticias-recolhida': noticiasRecolhida }">
        <div class="home-grid__agenda bloco margem" :class="{ 'home-grid__agenda--recolhida': agendaRecolhida }">
          <template v-if="agendaRecolhida">
            <div class="card-recolhido-resumo card-recolhido-resumo--agenda" role="button" tabindex="0" :title="`${resumoAgenda.total} evento(s). Clique para expandir.`" @click="agendaRecolhida = !agendaRecolhida" @keydown.enter.prevent="agendaRecolhida = !agendaRecolhida" @keydown.space.prevent="agendaRecolhida = !agendaRecolhida">
              <a class="icone-menu2 card-recolhido-icone-topo" href="#" aria-label="Expandir agenda" @click.prevent.stop="agendaRecolhida = !agendaRecolhida"></a>
              <h3 class="card-recolhido-titulo">Agenda</h3>
              <div class="resumo-circulos">
                <div v-for="(d, i) in resumoAgenda.dias" :key="i" class="resumo-circulo" :class="{ 'resumo-circulo--ativo': d.hoje }" :title="`${d.label}: ${d.count} evento(s)`">
                  <span class="resumo-circulo-inicial">{{ d.label }}</span>
                  <span class="resumo-circulo-count">{{ d.count }}</span>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="bloco-header-row">
              <a class="icone-menu2" href="#" title="Recolher agenda" @click.prevent="agendaRecolhida = !agendaRecolhida"></a>
              <h3 class="bloco-titulo">Sua Agenda</h3>
            </div>
            <div class="home-grid__agenda-conteudo">
              <template v-if="googleNotConnected">
                <div class="calendario-aviso-google">
                  <p>Conecte sua conta Google para ver os eventos da sua agenda. <a :href="urlConectarGoogle" target="_blank">Clique aqui para conectar</a>.</p>
                </div>
              </template>
              <template v-else-if="loadingCalendario">
                <p class="sem-itens">Carregando calendário...</p>
              </template>
              <CalendarioSimples v-else :eventos="eventosCalendario" @periodo-change="onPeriodoCalendarioChange" @event-click="aoClicarEventoAgenda" />
            </div>
          </template>
        </div>
        <div class="home-grid__center" :style="centerColumnStyle">
          <div class="home-grid__tarefas bloco margem">
            <div class="alinha-v tarefas-header">
              <h3 class="bloco-titulo">Tarefas</h3>
              <!-- <div class="tarefas-view-toggle" role="group" aria-label="Tipo de tarefas">
              <button type="button" class="tarefas-view-btn" :class="{ ativo: abaTarefas === 'suas' }"
                @click="abaTarefas = 'suas', getTarefas()">Minhas</button>
              <button type="button" class="tarefas-view-btn" :class="{ ativo: abaTarefas === 'time' }"
                @click="abaTarefas = 'time', getTarefas()">Do meu time</button>
            </div> -->
              <p v-if="periodoTarefas" class="tarefas-periodo-label">{{ labelPeriodoTarefas }}</p>
            </div>
            <div>
              <table class="tabela">
                <thead>
                  <tr>
                    <th>Nº</th>
                    <!-- <th>Responsável</th> -->
                    <th>Origem</th>
                    <th>Descrição</th>
                    <th>Fim Previsto</th>
                    <th style="text-align: center">Status</th>
                  </tr>
                </thead>
                <tbody v-if="!loadingTarefas">
                  <tr v-for="t in tarefas" :key="t.id" @click="verTarefas(t)">
                    <td style="white-space: nowrap">{{ t.codigo }}</td>
                    <!-- <td>{{ t.responsavel_nome }}</td> -->
                    <td>{{ t.pcm_codigo }}</td>
                    <td>
                      <span class="tarefa-descricao">{{ t.descricao }}</span>
                    </td>
                    <!-- <td>{{ formatarData(t.fimPrevisto) }}</td> -->
                    <td>
                      <div class="alinha-v" style="gap: 0.5rem">
                        {{ formatarData(t.dtFim) }}
                        <i v-if="t.dtFim && new Date().toISOString().split('T')[0] > t.dtFim" class="bi-exclamation-diamond-fill" style="font-size: 18px; color: var(--cor-erro)" title="Tarefa Atrasada"></i>
                      </div>
                    </td>
                    <td class="alinha-centro">
                      <span class="chip" :class="corStatusTarefas(t.status)">
                        {{ t.status }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p v-if="tarefas.length == 0 && !loadingTarefas" class="sem-itens">Nenhuma tarefa no período</p>
              <p v-if="loadingTarefas" class="sem-itens">Carregando tarefas...</p>
            </div>
          </div>
          <div v-if="splitterVisivel" class="home-grid__splitter" role="separator" aria-label="Redimensionar altura entre Tarefas e Demandas" @mousedown="onSplitterMouseDown"></div>
          <div class="home-grid__demandas bloco margem">
            <h3 class="bloco-titulo">Demandas</h3>
            <div>
              <table class="tabela">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Sua Função</th>
                    <th>Item</th>
                    <th style="text-align: center">Status</th>
                  </tr>
                </thead>
                <tbody v-if="!loadingDemandas">
                  <tr v-for="s in demandas" :key="s.id" @click="verDemandas(s.id)">
                    <td class="clicavel">{{ s.codigo }}</td>
                    <td>{{ getFuncaoNome(s) }}</td>
                    <td>
                      <div class="lista-itens">
                        <template v-for="(item, index) in s.itens" :key="index">
                          <div class="item-produto" :title="item.produto ? `${item.produto.cod} - ${item.produto.desc}` : '-'">
                            <span class="quantidade">{{ formatarQuantidade(item.qt_solicitada) }}</span>
                            <div class="detalhes-produto">
                              <span class="codigo-produto" v-if="item.produto?.cod || item.servico?.codigo_servico"> {{ item.produto?.cod || item.servico?.codigo_servico }} </span>
                              <span class="descricao-produto"
                                >{{ item.produto?.desc || item.servico?.descricao_servico || item.descricao || "-" }} <span v-if="!item.produto?.cod && !item.servico?.codigo_servico"><i class="bi-exclamation-triangle-fill alerta" title="Item não cadastrado"></i></span>
                              </span>
                            </div>
                          </div>
                        </template>
                      </div>
                    </td>
                    <td>
                      <div class="lista-itens">
                        <template v-for="(item, index) in s.itens" :key="index">
                          <div class="item-produto" style="justify-content: center">
                            <span class="chip" :class="corStatus(item.status)">
                              {{ formatarStatus(item.status) }}
                            </span>
                          </div>
                        </template>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p v-if="demandas.length == 0 && !loadingDemandas" class="sem-itens">Nenhuma demanda</p>
              <p v-if="loadingDemandas" class="sem-itens">Carregando demandas...</p>
            </div>
          </div>
        </div>
        <div class="home-grid__noticias bloco margem" :class="{ 'home-grid__noticias--recolhida': noticiasRecolhida }">
          <template v-if="noticiasRecolhida">
            <div class="card-recolhido-resumo card-recolhido-resumo--noticias" role="button" tabindex="0" :title="`${resumoNoticias.total} notícia(s). Clique para expandir.`" @click="noticiasRecolhida = !noticiasRecolhida" @keydown.enter.prevent="noticiasRecolhida = !noticiasRecolhida" @keydown.space.prevent="noticiasRecolhida = !noticiasRecolhida">
              <a class="icone-menu2 card-recolhido-icone-topo" href="#" aria-label="Expandir notícias" @click.prevent.stop="noticiasRecolhida = !noticiasRecolhida"></a>
              <h3 class="card-recolhido-titulo">Notícias</h3>
              <div class="resumo-noticias-conteudo">
                <span class="resumo-noticias-total">{{ resumoNoticias.total }} not.</span>
                <div class="resumo-noticias-bolinhas">
                  <span v-for="n in notificacoes" :key="n.id" class="resumo-noticias-bolinha" :class="'resumo-noticias-bolinha--' + (n.prioridade || 'baixa')" :title="n.titulo"></span>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="bloco-header-row">
              <a class="icone-menu2" href="#" title="Recolher notícias" @click.prevent="noticiasRecolhida = !noticiasRecolhida"></a>
              <div class="noticias-header">
                <h3 class="bloco-titulo">Noticias</h3>
                <!-- funcionalidade Noticias | Cadastrar -->
                <button class="btn-noticia-nova acao-secundaria" @click="abrirModalNoticia" v-if="funcionalidades.includes(184)">Adicionar</button>
              </div>
            </div>
            <div class="home-grid__noticias-conteudo">
              <ul class="lista-notificacoes">
                <li v-for="n in notificacoes" :key="n.id" class="notificacao-item bg-cinza" :class="{ 'bg-alerta': n.prioridade === 'alta', 'bg-ok': n.prioridade === 'media', 'bg-cinza': n.prioridade === 'baixa' }">
                  <div class="notificacao-conteudo">
                    <span class="notificacao-titulo">{{ n.titulo }}</span>
                    <i class="bi-trash" @click="excluirNoticia(n)" aria-label="Apagar notícia" v-if="funcionalidades.includes(184)" title="Apagar notícia"></i>
                  </div>
                  <p v-if="n.mensagem" class="notificacao-mensagem">{{ n.mensagem }}</p>
                  <a v-if="n.link" :href="n.link" target="_blank" class="noticia-link-saiba">Saiba mais</a>
                </li>
              </ul>
              <p v-if="loadingNoticias" class="sem-itens">Carregando notícias...</p>
              <p v-else-if="!notificacoes.length" class="sem-itens">Nenhuma notícia</p>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- Modal Cadastrar notícia -->
    <Teleport to="body">
      <div v-if="modalNoticiaAberto" class="modal-mask" @click.self="fecharModalNoticia">
        <div class="jm margem" style="min-width: 50vw" role="dialog" aria-labelledby="modal-noticia-titulo" aria-modal="true">
          <h2>Cadastrar notícia</h2>
          <form class="grid-1">
            <div>
              <label>Título</label>
              <input v-model="formNoticia.titulo" type="text" class="input" :required="!formNoticia.titulo" placeholder="Título da notícia" />
            </div>
            <div>
              <label>Mensagem</label>
              <textarea v-model="formNoticia.mensagem" :required="!formNoticia.mensagem" class="input" rows="4" placeholder="Conteúdo da notícia"></textarea>
            </div>
            <div>
              <label>Saiba Mais <i class="bi bi-info-circle" title="(opcional) | link que o usuario será redirecionado ao clicar em 'Saiba mais'"></i></label>
              <input v-model="formNoticia.link" type="url" class="input" placeholder="https://..." />
            </div>
            <div class="grid-2">
              <div>
                <label>Ativo até</label>
                <input v-model="formNoticia.valido_ate" :required="!formNoticia.valido_ate" type="date" class="input" />
              </div>
              <div>
                <label>Prioridade</label>
                <select v-model="formNoticia.prioridade" class="input">
                  <option value="baixa">Baixa</option>
                  <option value="media">Média</option>
                  <option value="alta">Alta</option>
                </select>
              </div>
            </div>
          </form>
          <div class="submit direita">
            <button class="acao-secundaria" @click="fecharModalNoticia">Cancelar</button>
            <button @click="salvarNoticia" :disabled="campoVazioNoticia">Salvar</button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { sso } from "roboflex-thalamus-sso-lib";
import CalendarioSimples from "@/components/CalendarioSimples.vue";
import { startOfDay, endOfDay, format, isSameDay, startOfWeek, addDays } from "date-fns";
import { ptBR } from "date-fns/locale";
import portalService from "@/services/portalService";
import { getPermissao } from "@/services/permissaoService";

export default {
  name: "HomeView",
  components: { CalendarioSimples },

  data() {
    return {
      funcionalidades: [],
      usuarioLogado: sso.getUsuarioLogado(),
      periodoTarefas: null,
      abaTarefas: "suas",
      tarefas: [],
      subordinados: [],
      loadingTarefas: true,
      eventosCalendario: [],
      googleNotConnected: false,
      loadingCalendario: true,
      urlConectarGoogle: "https://projetos.thalamus.ind.br/#/reunioes-google",
      notificacoes: [],
      loadingNoticias: false,
      demandas: [],
      loadingDemandas: true,
      modalNoticiaAberto: false,
      formNoticia: {
        titulo: "",
        mensagem: "",
        link: "",
        valido_ate: "",
        prioridade: "media",
      },
      splitRatioTarefas: 0.5,
      splitterDragging: false,
      initialRatioApplied: false,
      splitterVisivel: true,
      agendaRecolhida: false,
      noticiasRecolhida: false,
      relogioAgora: new Date(),
      relogioTimerId: null,
    };
  },
  created() {
    if (typeof window !== "undefined" && window.innerWidth <= 1440) {
      this.agendaRecolhida = true;
      this.noticiasRecolhida = true;
      const hoje = startOfDay(new Date());
      const inicioSemana = startOfWeek(hoje, { weekStartsOn: 0 });
      this.periodoTarefas = {
        tipo: "semana",
        inicio: inicioSemana,
        fim: addDays(inicioSemana, 6),
      };
    }
  },
  computed: {
    centerColumnStyle() {
      const r = Math.max(0.2, Math.min(0.8, this.splitRatioTarefas));
      return { "--split-ratio": r };
    },
    campoVazioNoticia() {
      return !this.formNoticia.titulo || !this.formNoticia.mensagem || !this.formNoticia.valido_ate;
    },
    inicioPeriodo() {
      if (!this.periodoTarefas) return null;
      if (this.periodoTarefas.tipo === "semana") return startOfDay(this.periodoTarefas.inicio);
      return startOfDay(this.periodoTarefas.data);
    },
    fimPeriodo() {
      if (!this.periodoTarefas) return null;
      if (this.periodoTarefas.tipo === "semana") return endOfDay(this.periodoTarefas.fim);
      return endOfDay(this.periodoTarefas.data);
    },
    labelPeriodoTarefas() {
      if (!this.periodoTarefas) return "";
      if (this.periodoTarefas.tipo === "semana") {
        // return `Tarefas da semana ${format(this.periodoTarefas.inicio, 'd MMM', { locale: ptBR })} – ${format(this.periodoTarefas.fim, 'd MMM yyyy', { locale: ptBR })}`;
        return `Suas tarefas a serem concluídas até ${format(this.periodoTarefas.fim, "EEEE, d 'de' MMMM", { locale: ptBR })}`;
      }
      return `Suas tarefas a serem concluídas até ${format(this.periodoTarefas.data, "EEEE, d 'de' MMMM", { locale: ptBR })}`;
    },
    /** Resumo para o card da agenda recolhido: 7 dias da semana com inicial, contagem e se é hoje. */
    resumoAgenda() {
      const hoje = startOfDay(new Date());
      const domingo = startOfWeek(hoje, { weekStartsOn: 0 });
      const dias = [];
      for (let i = 0; i < 7; i++) {
        const dia = addDays(domingo, i);
        const count = (this.eventosCalendario || []).filter((e) => {
          const d = e.start instanceof Date ? e.start : new Date(e.start);
          return isSameDay(d, dia);
        }).length;
        dias.push({
          label: format(dia, "EEE", { locale: ptBR }).slice(0, 3),
          count,
          hoje: isSameDay(dia, hoje),
        });
      }
      const total = (this.eventosCalendario || []).length;
      return { total, dias };
    },
    /** Resumo para o card de notícias recolhido: total e contagem por prioridade. */
    resumoNoticias() {
      const altas = this.notificacoes.filter((n) => n.prioridade === "alta").length;
      const medias = this.notificacoes.filter((n) => n.prioridade === "media").length;
      const baixas = this.notificacoes.filter((n) => n.prioridade === "baixa").length;
      return {
        total: this.notificacoes.length,
        altas,
        medias,
        baixas,
      };
    },
    textoDataHoraRelogio() {
      return format(this.relogioAgora, "EEE, d MMM yyyy · HH:mm", { locale: ptBR });
    },
  },
  methods: {
    getFuncaoNome(s) {
      var funcoes = [];
      if (s?.usuario?.id === this.usuarioLogado.id) {
        funcoes.push("Criador");
      }
      if (s?.solicitante?.id === this.usuarioLogado.id) {
        funcoes.push("Lider Responsável");
      }
      return funcoes.length > 0 ? funcoes.join(", ") : "Admin";
    },
    async getDemandas() {
      this.loadingDemandas = true;
      try {
        const response = await portalService.getDemandas(this.usuarioLogado.id);
        var demandasComItensFiltrados = response.map((d) => ({
          ...d,
          itens: d.itens.filter((i) => !["Entregue", "finalizada_almoxarifado", "Reprovado", "pagamento_finalizado", "Cancelado", "rejeitado"].includes(i.status)),
        }));
        this.demandas = demandasComItensFiltrados.filter((d) => d.itens.length > 0);
      } catch (error) {
        console.error("Erro ao buscar demandas:", error);
      } finally {
        this.loadingDemandas = false;
      }
    },
    verDemandas(id) {
      window.open(`https://demandas.thalamus.ind.br/#/minhas-demandas/${id}`, "_blank");
    },
    verTarefas(tarefa) {
      const base = "https://projetos.thalamus.ind.br/#/";
      const params = new URLSearchParams();
      params.set("fromPortal", "1");
      if (this.fimPeriodo) params.set("periodoFim", format(this.fimPeriodo, "yyyy-MM-dd"));
      const ids = this.abaTarefas === "suas" ? [this.usuarioLogado.id] : (this.subordinados || []).map((s) => s.valor);
      if (ids.length) params.set("idUser", ids.join(","));
      params.set("statusTarefas", "Pendente,Em andamento");
      params.set("destaque_tarefa_id", String(tarefa.id));
      window.open(`${base}?${params.toString()}`, "_blank");
    },
    async getTarefas() {
      if (!this.periodoTarefas) return;
      this.loadingTarefas = true;
      try {
        const payload = {
          idUser: this.abaTarefas === "suas" ? [{ valor: this.usuarioLogado.id }] : this.subordinados,
        };
        if (this.fimPeriodo) payload.dtFim = this.fimPeriodo.toISOString();
        const response = await portalService.getTarefas(payload);
        this.tarefas = response;
      } catch (error) {
        console.error("Erro ao buscar tarefas:", error);
      } finally {
        this.loadingTarefas = false;
      }
    },
    async getSubordinados() {
      const response = await portalService.getSubordinados(this.usuarioLogado.id);
      this.subordinados = response.map((s) => ({ valor: s.usuario_id }));
    },
    corStatusTarefas(status) {
      if (status === "Pendente") return "bg-alerta";
      if (status.startsWith("Em andamento")) return "bg-ok";
      if (status === "Concluído") return "bg-sucesso";
      return "bg-cinza";
    },
    formatarStatus(status) {
      const statusFormatados = {
        Pendente: "Em análise",
        cotacao: "Requisição Criada",
        aprovacao: "Cotação Realizada",
        rejeitado: "Item Reprovado",
        compra: "Cotação Aprovada",
        recebimento: "Aguardando Recebimento",
        almoxarifado: "Chegou na empresa",
        finalizada_almoxarifado: "Finalizada no almoxarifado",
        gestao: "Aguardando Execução",
        pagamento: "Pagamento Solicitado",
        pagamento_finalizado: "Pagamento Realizado",
        nao_recebido: "Item não Recebido",
      };
      return statusFormatados[status] ?? status;
    },
    corStatus(status) {
      const cores = {
        Rascunho: "bg-ok",
        "Cadastro Pendente": "bg-cinza",
        Pendente: "bg-cinza",
        Revisão: "bg-alerta",
        Autorizado: "bg-ok",
        Desautorizado: "bg-erro",
        Concluído: "bg-sucesso",
        "Em Separação": "bg-ok",
        Separado: "bg-ok",
        "Separado Parcialmente": "bg-ok",
        Entregue: "bg-sucesso",
        "Entregue Parcialmente": "bg-ok",
        Reprovado: "bg-erro",
        Cancelado: "bg-erro",
        Cotação: "bg-ok",
        Aprovado: "bg-ok",

        // Status de compras (em minúsculas)
        cotacao: "bg-ok",
        aprovacao: "bg-ok",
        rejeitado: "bg-erro",
        compra: "bg-ok",
        recebimento: "bg-ok",
        almoxarifado: "bg-ok",
        finalizada_almoxarifado: "bg-sucesso",
        gestao: "bg-ok",
        pagamento: "bg-ok",
        pagamento_finalizado: "bg-sucesso",
        nao_recebido: "bg-erro",
      };
      return cores[status] ?? "bg-ok";
    },
    formatarQuantidade(valor) {
      if (!valor && valor !== 0) return "-";

      // Converte para número
      const num = Number(valor);

      // Remove casas decimais zeradas
      const numSemZeros = num % 1 === 0 ? Math.floor(num) : num;

      // Formata no padrão brasileiro (pontos para milhares)
      return numSemZeros.toLocaleString("pt-BR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
    onPeriodoCalendarioChange(payload) {
      this.periodoTarefas = payload;
      this.getTarefas();
    },
    /** Redireciona para a página de Reuniões Google (projetos) com a reunião em destaque. */
    aoClicarEventoAgenda(ev) {
      if (!ev?.id) return;
      const url = `https://projetos.thalamus.ind.br/#/reunioes-google?reuniao_id=${encodeURIComponent(ev.id)}`;
      window.open(url, "_blank");
    },
    /** Mapeia reuniões da API Google Calendar para o formato do CalendarioSimples. */
    mapReunioesToEventos(events) {
      if (!Array.isArray(events)) return [];
      return events.map((ev) => {
        const startStr = ev.start || "";
        const allDay = !startStr.includes("T") || startStr.length === 10;
        const start = startStr ? new Date(startStr) : new Date();
        const attachments = Array.isArray(ev.attachments) ? ev.attachments : [];
        const gravacao = attachments.find((a) => a?.tipo === "gravacao" && a?.fileUrl);
        const transcricao = attachments.find((a) => a?.tipo === "transcricao" && a?.fileUrl);
        return {
          id: ev.id ?? ev.google_event_id,
          title: ev.summary || "(Sem título)",
          start,
          end: ev.end ? new Date(ev.end) : undefined,
          allDay,
          gravacaoUrl: gravacao?.fileUrl || null,
          transcricaoUrl: transcricao?.fileUrl || null,
        };
      });
    },
    async carregarEventosCalendario() {
      this.loadingCalendario = true;
      this.googleNotConnected = false;
      try {
        const data = await portalService.getReunioesGoogle();
        this.eventosCalendario = this.mapReunioesToEventos(data.events || []);
      } catch (err) {
        if (err.response?.status === 403 && err.response?.data?.code === "google_not_connected") {
          this.googleNotConnected = true;
        } else {
          console.error("Erro ao carregar calendário:", err);
        }
      } finally {
        this.loadingCalendario = false;
      }
    },
    getMensagemBemVindo() {
      const hora = new Date().getHours();
      if (hora < 12) return "Bom dia";
      if (hora < 18) return "Boa tarde";
      return "Boa noite";
    },
    formatarData(d) {
      const date = d instanceof Date ? d : new Date(d);
      return format(date, "dd/MM/yyyy", { locale: ptBR });
    },
    abrirModalNoticia() {
      this.formNoticia = { titulo: "", mensagem: "", link: "", valido_ate: "", prioridade: "media" };
      this.modalNoticiaAberto = true;
    },
    fecharModalNoticia() {
      this.modalNoticiaAberto = false;
    },
    prioridadeParaLabel(val) {
      const map = { 1: "baixa", 2: "media", 3: "alta" };
      return map[Number(val)] ?? "media";
    },
    prioridadeParaNumero(label) {
      const map = { baixa: 1, media: 2, alta: 3 };
      return map[label] ?? 2;
    },
    async getNoticias() {
      this.loadingNoticias = true;
      try {
        const data = await portalService.getNoticias();
        this.notificacoes = (data || []).map((n) => ({
          id: n.id,
          titulo: n.titulo ?? "",
          mensagem: n.descricao ?? "",
          link: n.link ?? "",
          valido_ate: n.valido_ate ?? null,
          prioridade: this.prioridadeParaLabel(n.prioridade),
        }));
      } catch (error) {
        console.error("Erro ao buscar notícias:", error);
      } finally {
        this.loadingNoticias = false;
      }
    },
    async excluirNoticia(noticia) {
      if (!confirm(`Apagar a notícia "${noticia.titulo}"?`)) return;
      try {
        await portalService.deleteNoticia(noticia.id);
        await this.getNoticias();
      } catch (error) {
        console.error("Erro ao apagar notícia:", error);
      }
    },
    async salvarNoticia() {
      try {
        await portalService.createNoticia({
          titulo: this.formNoticia.titulo.trim(),
          descricao: (this.formNoticia.mensagem || "").trim() || null,
          link: (this.formNoticia.link || "").trim() || null,
          valido_ate: this.formNoticia.valido_ate || null,
          prioridade: this.prioridadeParaNumero(this.formNoticia.prioridade),
        });
        this.fecharModalNoticia();
        await this.getNoticias();
      } catch (error) {
        console.error("Erro ao cadastrar notícia:", error);
      }
    },
    getStoredSplitRatio() {
      try {
        const v = localStorage.getItem("home_split_ratio");
        if (v != null) {
          const n = Number(v);
          if (Number.isFinite(n) && n >= 0.2 && n <= 0.8) return n;
        }
      } catch (_) {
        /* localStorage indisponível */
      }
      return null;
    },
    persistSplitRatio() {
      try {
        localStorage.setItem("home_split_ratio", String(this.splitRatioTarefas));
      } catch (_) {
        /* localStorage indisponível */
      }
    },
    applyInitialRatioFromCounts() {
      if (this.initialRatioApplied) return;
      if (this.getStoredSplitRatio() != null) return;
      if (this.loadingTarefas || this.loadingDemandas) return;
      const total = this.tarefas.length + this.demandas.length;
      if (total === 0) return;
      const r = Math.max(0.2, Math.min(0.8, this.tarefas.length / total));
      this.splitRatioTarefas = r;
      this.initialRatioApplied = true;
    },
    onSplitterMouseDown(ev) {
      ev.preventDefault();
      this.splitterDragging = true;
      const startY = ev.clientY;
      const startRatio = this.splitRatioTarefas;
      const el = this.$el.querySelector(".home-grid__center");
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const totalH = rect.height;

      const onMove = (e) => {
        const dy = e.clientY - startY;
        const deltaRatio = dy / totalH;
        let r = startRatio + deltaRatio;
        r = Math.max(0.2, Math.min(0.8, r));
        this.splitRatioTarefas = r;
      };
      const onUp = () => {
        this.splitterDragging = false;
        this.persistSplitRatio();
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onUp);
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
      };

      document.body.style.cursor = "row-resize";
      document.body.style.userSelect = "none";
      document.addEventListener("mousemove", onMove);
      document.addEventListener("mouseup", onUp);
    },
    updateSplitterVisivel() {
      this.splitterVisivel = window.innerWidth >= 971;
    },
  },
  async mounted() {
    const stored = this.getStoredSplitRatio();
    if (stored != null) this.splitRatioTarefas = stored;
    this.splitterVisivel = window.innerWidth >= 971;
    window.addEventListener("resize", this.updateSplitterVisivel);

    this.getTarefas();
    this.getSubordinados();
    this.getDemandas();
    this.getNoticias();
    this.carregarEventosCalendario();
    this.funcionalidades = await getPermissao();
    this.applyInitialRatioFromCounts();
    this.relogioTimerId = setInterval(() => {
      this.relogioAgora = new Date();
    }, 1000);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateSplitterVisivel);
    if (this.relogioTimerId != null) {
      clearInterval(this.relogioTimerId);
      this.relogioTimerId = null;
    }
  },
  watch: {
    loadingTarefas: "applyInitialRatioFromCounts",
    loadingDemandas: "applyInitialRatioFromCounts",
  },
};
</script>

<style scoped>
.calendario-aviso-google {
  padding: 1rem;
  background: rgba(255, 193, 7, 0.12);
  border: 1px solid rgba(255, 193, 7, 0.4);
  border-radius: 8px;
  color: var(--cor-fonte);
}

.calendario-aviso-google p {
  margin: 0;
  font-size: 0.95rem;
}

.calendario-aviso-google a {
  color: var(--cor-primaria);
  font-weight: 600;
  text-decoration: underline;
}

.calendario-aviso-google a:hover {
  text-decoration: none;
}

.home-view {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.home-view .titulo {
  flex-shrink: 0;
}

.home-grid-wrap {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.home-grid {
  height: 100%;
  min-height: 0;
  grid-auto-rows: minmax(0, 1fr);
}

.home-grid--custom {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: 1fr;
  gap: var(--margem);
  grid-auto-rows: minmax(0, 1fr);
}

.home-grid--custom .home-grid__agenda {
  grid-column: 1;
  grid-row: 1;
}

.home-grid--agenda-recolhida {
  grid-template-columns: auto 2fr 1fr;
}

.home-grid--noticias-recolhida {
  grid-template-columns: 1fr 2fr auto;
}

.home-grid--agenda-recolhida.home-grid--noticias-recolhida {
  grid-template-columns: auto 2fr auto;
}

.home-grid__agenda--recolhida {
  display: flex;
  align-items: stretch;
  justify-content: center;
  min-width: 0;
  overflow: hidden;
  min-width: 72px;
}

.home-grid__agenda--recolhida.bloco,
.home-grid__noticias--recolhida.bloco {
  overflow: hidden;
}

.home-grid__agenda--recolhida .icone-menu,
.home-grid__agenda--recolhida .icone-menu2 {
  flex-shrink: 0;
}

/* Resumo nos cards recolhidos: ícone no topo (como quando aberto), círculos/quadrados 48px, sem rolagem */
.card-recolhido-resumo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 0.5rem;
  min-width: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  text-align: center;
  color: var(--cor-fonte, #333);
  overflow: hidden;
  overflow-y: hidden;
}

.card-recolhido-icone-topo {
  flex-shrink: 0;
  display: block;
}

.card-recolhido-titulo {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--cor-primaria);
  margin: 0;
  flex-shrink: 0;
  text-align: center;
}

/* Círculos da agenda: 1 por dia da semana (tamanho do ícone 48px), inicial + contador, dia atual com .ativo */
.resumo-circulos {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.resumo-circulo {
  width: 48px;
  height: 48px;
  min-width: 48px;
  min-height: 48px;
  border-radius: 50%;
  border: 2px solid var(--cor-separador, rgba(0, 0, 0, 0.2));
  background: var(--cor-bg, #fff);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.65rem;
  line-height: 1.1;
}

.resumo-circulo-inicial {
  font-weight: 700;
  text-transform: capitalize;
  color: var(--cor-fonte-fraca, #666);
}

.resumo-circulo-count {
  font-weight: 700;
  font-size: 0.8rem;
  color: var(--cor-fonte, #333);
}

.resumo-circulo--ativo {
  border-color: var(--cor-primaria);
  background: var(--cor-primaria-fraca, rgba(0, 123, 255, 0.08));
}

.resumo-circulo--ativo .resumo-circulo-inicial,
.resumo-circulo--ativo .resumo-circulo-count {
  color: var(--cor-primaria);
}

/* Notícias recolhidas: total + bolinhas coloridas por prioridade (1 por notícia), tooltip = título */
.resumo-noticias-conteudo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.resumo-noticias-total {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--cor-fonte, #333);
  flex-shrink: 0;
}

.resumo-noticias-bolinhas {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.resumo-noticias-bolinha {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
}

.resumo-noticias-bolinha--alta {
  background: var(--cor-alerta);
}

.resumo-noticias-bolinha--media {
  background: var(--cor-ok);
}

.resumo-noticias-bolinha--baixa {
  background: var(--cor-separador);
}

.home-grid--custom .home-grid__center {
  grid-column: 2;
  grid-row: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.home-grid--custom .home-grid__center .home-grid__tarefas {
  flex: var(--split-ratio, 0.5) 1 0;
  min-height: 0;
}

.home-grid--custom .home-grid__splitter {
  flex: 0 0 6px;
  min-height: 6px;
  margin: 8px 0;
  cursor: row-resize;
  background: var(--cor-separador, rgba(0, 0, 0, 0.12));
  position: relative;
  border-radius: 12px;
}

.home-grid--custom .home-grid__splitter:hover,
.home-grid--custom .home-grid__splitter:focus {
  background: var(--cor-primaria-fraca, rgba(0, 123, 255, 0.3));
}

.home-grid--custom .home-grid__splitter::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 12px;
  margin-top: -6px;
}

.home-grid--custom .home-grid__center .home-grid__demandas {
  flex: calc(1 - var(--split-ratio, 0.5)) 1 0;
  min-height: 0;
}

.home-grid--custom .home-grid__noticias {
  grid-column: 3;
  grid-row: 1;
}

.home-grid__noticias--recolhida {
  display: flex;
  align-items: stretch;
  justify-content: center;
  min-width: 0;
  overflow: hidden;
  min-width: 72px;
}

.home-grid__noticias--recolhida .icone-menu,
.home-grid__noticias--recolhida .icone-menu2 {
  flex-shrink: 0;
}

.home-grid-wrap .bloco,
.home-grid-wrap .bloco2 {
  min-height: 0;
  overflow-y: auto;
}

.home-grid-wrap .home-grid__agenda--recolhida.bloco,
.home-grid-wrap .home-grid__noticias--recolhida.bloco {
  overflow-y: hidden !important;
}

.row-2 {
  grid-row: span 2;
}

@media screen and (max-width: 1100px) {
  .home-grid--custom {
    grid-template-columns: minmax(280px, 1fr) minmax(280px, 1fr);
    grid-template-rows: 1fr 1fr;
  }

  .home-grid--custom.home-grid--agenda-recolhida {
    grid-template-columns: auto minmax(280px, 1fr);
  }

  .home-grid--custom.home-grid--noticias-recolhida {
    grid-template-rows: 1fr auto;
  }

  .home-grid--custom .home-grid__agenda {
    grid-column: 1;
    grid-row: 1 / -1;
  }

  .home-grid--custom .home-grid__center {
    grid-column: 2;
    grid-row: 1;
  }

  .home-grid--custom .home-grid__splitter {
    display: none;
  }

  .home-grid--custom .home-grid__noticias {
    grid-column: 2;
    grid-row: 2;
  }
}

@media screen and (max-width: 970px) {
  .home-grid--custom {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }

  .home-grid--custom .home-grid__agenda,
  .home-grid--custom .home-grid__center,
  .home-grid--custom .home-grid__noticias {
    grid-column: 1;
    grid-row: auto;
  }

  .home-grid--custom .home-grid__center {
    min-height: 300px;
  }
}

.tarefas-header {
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.tarefas-view-toggle {
  display: inline-flex;
  padding: 3px;
  border-radius: 10px;
  background: var(--cor-cinza2, rgba(0, 0, 0, 0.06));
  border: 1px solid var(--cor-separador);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.tarefas-view-btn {
  border: none;
  background: transparent;
  color: var(--cor-fonte);
  padding: 0.45rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.tarefas-view-btn:hover:not(.ativo) {
  color: var(--cor-fonte-forte);
  background: rgba(255, 255, 255, 0.5);
}

.tarefas-view-btn.ativo {
  background: var(--cor-primaria);
  color: var(--cor-bg);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.tarefas-periodo-label {
  font-size: 0.85rem;
  color: var(--cor-fonte-fraca);
}

.tarefa-descricao {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  max-height: 3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

.bloco-header-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  flex-shrink: 0;
}

.bloco-header-row .bloco-titulo {
  margin: 0;
  flex: 1;
  min-width: 0;
}

.bloco-titulo {
  font-size: 1rem;
  font-weight: 600;
  color: var(--cor-primaria);
  margin: 0 0 0.75rem 0;
}

.noticias-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0;
  flex: 1;
  min-width: 0;
}

.noticias-header .bloco-titulo {
  margin: 0;
}

.btn-noticia-nova {
  padding: 0.4rem 0.75rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--cor-fonte);
  background-color: var(--cor-cinza2);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s, box-shadow 0.2s;
}

.btn-noticia-nova:hover {
  opacity: 0.9;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* Modal cadastrar notícia */
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.lista-notificacoes {
  list-style: none;
  padding: 0;
  margin: 0;
}

.notificacao-item {
  padding: 0.5rem 1rem;
  border-radius: 12px;
  border-bottom: 1px solid var(--cor-separador);
  margin-bottom: 6px;
}

.notificacao-item:last-child {
  border-bottom: none;
}

.notificacao-conteudo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.notificacao-titulo {
  flex: 1;
  font-size: 1rem;
}

.bi-trash {
  font-size: 1rem;
  cursor: pointer;
}

.bi-trash:hover {
  color: var(--cor-erro, #c00);
}

.notificacao-data,
.notificacao-mensagem {
  font-size: 0.9rem;
}

.notificacao-mensagem {
  margin: 0.25rem 0 0 0;
}

.noticia-link,
.noticia-link-saiba {
  color: var(--cor-fonte-fraca);
  text-decoration: none;
  font-size: 0.8rem;
}

.noticia-link:hover,
.noticia-link-saiba:hover {
  text-decoration: underline;
}

.noticia-link-saiba {
  display: inline-block;
  margin-top: 0.25rem;
}

.sem-itens {
  color: var(--cor-fonte-fraca);
  font-size: 0.9rem;
  margin: 0.5rem 0 0 0;
}

.item-produto {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.5rem;
  background: var(--cor-fundo-escuro);
  border-radius: 4px;
  transition: background-color 0.2s;
}

/* .item-produto:hover {
    background: rgba(var(--cor-primaria-rgb, 0, 0, 0), 0.05);
} */

.quantidade {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1rem;
  height: 1.5rem;
  padding: 0 0.5rem;
  background: var(--cor-separador);
  color: var(--cor-fonte);
  border-radius: 12px;
  font-size: 0.85em;
  font-weight: 600;
  flex-shrink: 0;
}

.detalhes-produto {
  display: flex;
  gap: 0.25rem;
  flex: 1;
  min-width: 0;
}

.codigo-produto {
  color: var(--cor-fonte-fraca, #666);
  font-weight: 500;
}

.descricao-produto {
  color: var(--cor-fonte, #333);
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lista-itens {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 100%;
}

.item-expansivel {
  margin-top: 0.25rem;
}

.resumo-expansao {
  cursor: pointer;
  padding: 0.5rem;
  background: var(--cor-fundo-escuro);
  border-radius: 4px;
  font-size: 0.85em;
  color: var(--cor-primaria, #007bff);
  font-weight: 500;
  text-align: center;
  transition: background-color 0.2s;
  list-style: none;
}

.resumo-expansao:hover {
  background: rgba(var(--cor-primaria-rgb, 0, 123, 255), 0.1);
}

.resumo-expansao::-webkit-details-marker {
  display: none;
}

.itens-adicionais {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.sem-itens {
  color: var(--cor-fonte-fraca, #666);
  font-size: 0.9em;
  font-style: italic;
  padding: 0.5rem;
  text-align: center;
}

.item-produto {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.5rem;
  background: var(--cor-fundo-escuro);
  border-radius: 4px;
  transition: background-color 0.2s;
}

/* .item-produto:hover {
    background: rgba(var(--cor-primaria-rgb, 0, 0, 0), 0.05);
} */

.quantidade {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1rem;
  height: 1.5rem;
  padding: 0 0.5rem;
  background: var(--cor-separador);
  color: var(--cor-fonte);
  border-radius: 12px;
  font-size: 0.85em;
  font-weight: 600;
  flex-shrink: 0;
}

.detalhes-produto {
  display: flex;
  gap: 0.25rem;
  flex: 1;
  min-width: 0;
}

.codigo-produto {
  color: var(--cor-fonte-fraca, #666);
  font-weight: 500;
}

.descricao-produto {
  color: var(--cor-fonte, #333);
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
